import { createFeatureSelector, createSelector } from '@ngrx/store';
import { promoCodeFeatureKey, PromoCodeState } from '@store/promocode/promocode.reducer';

const selectState = createFeatureSelector<PromoCodeState>(promoCodeFeatureKey);

const selectError = createSelector(
  selectState,
  (state) => state.error,
);
const selectPromoCode = createSelector(
  selectState,
  (state) => state.promoCode,
);
const selectCode = createSelector(
  selectState,
  (state) => state.code,
);
const selectIsCodeValidatePending = createSelector(
  selectState,
  (state) => state.isLoading,
);
const selectIsPromoCodeApplied = createSelector(
  selectState,
  (state) => state.isPromoCodeApplied,
);
const selectPromoCodes = createSelector(
  selectState,
  (state) => state.list,
);
const selectIsListLoading = createSelector(
  selectState,
  (state) => state.isListLoading,
);
const selectListError = createSelector(
  selectState,
  (state) => state.listError,
);

export const promoCodeSelectors = {
  selectState,
  selectError,
  selectPromoCode,
  selectCode,
  selectIsCodeValidatePending,
  selectIsPromoCodeApplied,
  selectPromoCodes,
  selectIsListLoading,
  selectListError,
};